<!-- div class="learn-container  md:pt-[70px] "> -->
    <div class="learn-container bg-gray-50 md:pt-[70px]" >
        <msc-header [company]="company" [access]="access"></msc-header>
        <div class="learn-content-grid">
            <!--<msc-sidebar [me]="me" [company]="company" [access]="access" [sidebar]="sidebar" [class.expanded]="sidebarExpanded" (toggle)="toggleSidebar()"></msc-sidebar>-->
            <section infinite-scroll [scrollWindow]="false" [infiniteScrollDistance]="2" [infiniteScrollThrottle]="0"
                (scrolled)="loadMoreEmit()" infiniteScrollTrigger>
                <router-outlet></router-outlet>
            </section>
        </div>
    </div>